import {Field} from 'formik';


import {
    FormikSelect,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>

            <PlatformFieldset legend={'Payment Method Details'} variant={'filled'}>

                <Field
                    name='type'
                    label='Type'
                    description='Please select the payment method type'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'card',
                            label: 'Card'
                        },
                        {
                            value: 'usBankAccount',
                            label: 'US Bank Account'
                        },
                        {
                            value: 'sepaDebit',
                            label: 'SEPA Debit'
                        },
                        {
                            value: 'link',
                            label: 'Link'
                        },
                        {
                            value: 'paypal',
                            label: 'PayPal'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='customerId'
                    label='Customer'
                    description='Please select the customer'
                    component={CustomersAutocomplete}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Billing Details'} variant={'filled'}>

                <Field
                    name='billingDetails.name'
                    label='Name'
                    description='Please enter billing name'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='billingDetails.email'
                    label='Email'
                    description='Please enter billing email'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='billingDetails.phone'
                    label='Phone'
                    description='Please enter billing phone'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='billingDetails.address'
                    label='Address'
                    description='Please enter billing address'
                    component={FormikTextInput}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Card Details'} variant={'filled'}>

                <Field
                    name='card.number'
                    label='Card Number'
                    description='Please enter card number'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='card.expMonth'
                    label='Expiry Month'
                    description='Please enter expiry month'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='card.expYear'
                    label='Expiry Year'
                    description='Please enter expiry year'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='card.cvc'
                    label='CVC'
                    description='Please enter CVC'
                    component={FormikTextInput}
                    my={'xl'}
                />

            </PlatformFieldset>

        </Stack>
    );
};
